<template>
    <Modal class="time-error-modal"
           icon="fa-triangle-exclamation"
           title="CLOCK.TIME_ERROR_MODAL_TITLE">
        <div v-if="rechecking"
             class="text-center">
            <PageLoadingSpinner />
        </div>
        <div v-else
             class="text-center">
            <div class="alert alert-danger text-base-size">
                <template v-if="hasRechecked">
                    {{ l('CLOCK.TIME_ERROR_MSG_1__RECHECKED') }}
                </template>
                <template v-else>
                    {{ l('CLOCK.TIME_ERROR_MSG_1') }}
                </template>
            </div>

            <div class="flex--desktop mb-1">
                <div class="flex--grow flex--shrink flex--basis-1-percent">
                    <p>
                        <small>
                            <i class="fa-regular fa-clock fa-fw"></i>
                            {{ l('CLOCK.TIME_ERROR_SERVER_TIME') }}
                        </small>
                    </p>
                    <p class="text-lg">
                        <strong>
                            {{ momentFilter(serverTime, DateFormat.DATE_WITH_TIME_WITH_SECS) }}
                        </strong>
                    </p>
                </div>

                <div class="flex--grow flex--shrink flex--basis-1-percent">
                    <p>
                        <small>
                            <i class="fa-regular fa-cash-register fa-fw"></i>
                            {{ l('CLOCK.TIME_ERROR_SYSTEM_TIME') }}
                        </small>
                    </p>
                    <p class="text-lg text-danger">
                        <strong>
                            {{ momentFilter(systemTime, DateFormat.DATE_WITH_TIME_WITH_SECS) }}
                        </strong>
                    </p>
                </div>
            </div>

            <p class="text-base-size">
                {{ l('CLOCK.TIME_ERROR_MSG_2') }}
            </p>

            <h5 v-if="currentDeviceID"
                class="mb-0">
                <small>{{ l('ABOUT.DEVICE_ID') }}: {{ currentDeviceID }}</small>
            </h5>
        </div>

        <template v-slot:footer>
            <div v-show="!rechecking"
                 class="modl-footer">
                <SquareBtn color="default"
                           size="lg"
                           @click="recheck">
                    {{ l('CLOCK.TIME_ERROR_RECHECK_BTN') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import DateFormat from '@/lib/Dates/DateFormat';
import Modal from '@/vue/components/Modals/Modal';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'TimeErrorModal',

    components: { Modal, SquareBtn, PageLoadingSpinner },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        systemTime: {
            type: Date,
            required: true,
        },
        serverTime: {
            type: Date,
            required: true,
        },
        hasRechecked: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            DateFormat,
            currentDeviceID: container.currentDevice.getDeviceId(),
            rechecking: false,
        };
    },

    methods: {
        recheck() {
            this.rechecking = true;
            // Wait a bit so the user has time to see the loading spinner,
            // otherwise the spinner flashes too quickly and it doesn't look like it did anything.
            setTimeout(() => container.timeSyncer.recheck(), 500);
        },
    },
};
</script>
